import { createRoot } from 'react-dom/client';
import Host from './Host.jsx';

createRoot(document.getElementById('root')).render(<Host />);
